/**
 * Route guard. Until the silent-refresh bootstrap finishes we render a loader so
 * we never flash the login screen for users that *have* a valid refresh cookie
 * (fix for review finding C-1). After bootstrap, unauthenticated users get
 * redirected to `/login` with their original location stored in `return_to`.
 */

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '@/lib/auth-provider';
import { safeReturnTo } from '@/lib/session-expired-modal';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isBootstrapping } = useAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <Center mih="100dvh">
        <Loader aria-label="Проверяем сессию…" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    const target = safeReturnTo(location.pathname + location.search);
    const search = target === '/' ? '' : `?return_to=${encodeURIComponent(target)}`;
    return <Navigate to={`/login${search}`} replace />;
  }

  return <>{children}</>;
}
